import React from 'react';
import PropTypes from 'prop-types';

import { StyledSelect } from './CollectionSortStyles';

var _ref2 = React.createElement(
  'option',
  { disabled: true, value: '' },
  'Sort By'
);

var _ref3 = React.createElement(
  'option',
  { value: 'best-selling' },
  'Best Selling'
);

var _ref4 = React.createElement(
  'option',
  { value: 'created-at' },
  'Newest'
);

var _ref5 = React.createElement(
  'option',
  { value: 'price-asc' },
  'Price: Low to High'
);

var _ref6 = React.createElement(
  'option',
  { value: 'price-desc' },
  'Price: High to Low'
);

var CollectionSort = function CollectionSort(_ref) {
  var sortBy = _ref.sortBy,
      handleSortByChange = _ref.handleSortByChange;
  return React.createElement(
    StyledSelect,
    {
      defaultValue: sortBy,
      onChange: handleSortByChange,
      'aria-label': 'Sort Products By'
    },
    _ref2,
    _ref3,
    _ref4,
    _ref5,
    _ref6
  );
};

CollectionSort.propTypes = {
  handleSortByChange: PropTypes.func.isRequired,
  sortBy: PropTypes.string
};

export default CollectionSort;